/**
 * Publish only the NEWEST snapshot's result.
 *
 * A snapshot is decoded asynchronously — every row is decrypted — so two arriving close together can finish
 * in either order, and the older one finishing last publishes a list the reader has already moved past. The
 * two places it matters are the two places it is used: presence, where it is a session flickering back to a
 * state it has left, and a thread, where it is messages disappearing and coming back.
 *
 * Ordering by a counter rather than by arrival, because "later" is decided when the snapshot ARRIVES; which
 * decode finishes first is exactly the thing not to trust.
 */
export function latestOnly<T>(publish: (value: T) => void): (work: Promise<T>) => void {
  let newest = 0;
  return (work) => {
    const mine = ++newest;
    void work.then((value) => {
      // A result that is no longer the newest is dropped rather than published late. It is not merged
      // either: it describes the whole collection at an earlier moment, so half of it would be stale too.
      if (mine === newest) publish(value);
    });
  };
}
